import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form
} from "reactstrap";

import FilesCustom from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import { withRouter } from 'components/withRouter';

class ManageEmployees extends Component {
    static displayName = ManageEmployees.name;

    static employeeSchema;
    static employeeModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    constructor(props) {
        super(props);

        this.employeeGen = React.createRef(null);

        this.state = { employees: [], curEmployee: null, curEmployeeId: 0, status: [], defaultStatus: 1000, curStatus: 1000/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1", title: props.i18nManager.t("employee.noSelected"), editionMode: false };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            commonFunc.getMethod("../api/employee/GetEmployeeModels", { id: -1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.employeeModels = {};
                    dataModels.result.models.forEach((model) => {
                        var modelObj = JSON.parse(model.value);
                        if (!modelObj.objType) {//Array.isArray(modelObj)
                            var useSub = false;
                            Object.keys(modelObj).forEach(key => {
                                var subModel = modelObj[key];
                                if (subModel.objType) {
                                    useSub = true;
                                    context.employeeModels[key] = subModel;
                                }
                            });
                            if (!useSub) context.employeeModels[model.extID] = modelObj;
                        }
                        else context.employeeModels[model.extID] = modelObj;
                    });

                    /*commonFunc.getMethod("../api/employee/GetSchemaModel", null).then((response) => {
                        var dataSchema = response.data
                        if (dataSchema.isSuccess) {

                            context.employeeSchema = dataSchema.result;*/

                            //Chargement via url
                            var defEmployeeLoadId = 0;
                            var defEmployeeActionId = 0;
                            if (context.props.searchParams) {
                                defEmployeeLoadId = parseInt(context.props.searchParams.get("employeeId")) || 0;
                                defEmployeeActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                            }
                            if (defEmployeeLoadId > 0) {
                                var defEmployeeStatusId = parseInt(context.props.searchParams.get("statusId")) || 1000;

                                context.loadStatusBtnGrp(defEmployeeStatusId);

                                context.getEmployees(defEmployeeStatusId, false, function () {
                                    if (context) {
                                        context.loadReportCb = () => {
                                            if (defEmployeeActionId) context.switchTab(defEmployeeActionId.toString());

                                            //setTimeout(function () {
                                            var element = document.querySelector('.tableContainer');
                                            const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                            context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                            //}, 2000);
                                        };
                                    }
                                    showDtSelID("tableEmployees", defEmployeeLoadId);
                                });
                            } else {
                                context.loadStatusBtnGrp(1000);

                                context.getEmployees();

                                if (defEmployeeActionId) context.switchTab(defEmployeeActionId.toString());

                                /*if (defEmployeeActionId == 1) {
                                    $(".action-addReport:visible").click();
                                }*/
                            }

                        /*}
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur lors de la récupération du schéma employé"
                            });
                        }
                    });*/
                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (/*prevState.historicalReports !== this.state.historicalReports ||*/ prevState.curStatus !== this.state.curStatus) {
            this.getEmployees();
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateEmployee
        if (this.state.curEmployeeId === 0 /*&& prevState.curEmployeeId !== this.state.curEmployeeId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableEmployees"]) this.dtFunctions["tableEmployees"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;
        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadEmployee(rowData.idEmployee, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idEmployee;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadEmployee(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadEmployee();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        var pageConfig;
        switch (context.state.pageModels) {
            default:
                if (false && context.employeeModels && context.employeeModels["TABS_CONFIG"]) {
                    pageConfig = context.employeeModels["TABS_CONFIG"];
                }
                else {
                    pageConfig = {
                        "objType": "model", "templates": [
                            { "title": "i18n:employee.tabDetails", "objType": "template", "subType": "EMPLOYEE", "checkRights": { "entity": "EMPLOYEE", "rights": "R" } },
                            { "title": "i18n:employee.tabContracts", "objType": "template", "subType": "CONTRACTS", "checkRights": { "entity": "EMPLOYEE_CONTRACTS", "rights": "L" } },
                            { "title": "i18n:employee.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "EMPLOYEE_FILES", "rights": "L" } },
                            //{ "title": "i18n:employee.tabItvs", "objType": "template", "subType": "EVENTS", "checkRights": { "entity": "EMPLOYEE_EVENTS", "rights": "L" } },
                            { "title": "i18n:employee.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "EMPLOYEE_CONTACTS", "rights": "L" } },
                            { "title": "i18n:employee.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "EMPLOYEE_FLOWS", "rights": "L" } },
                            { "title": "i18n:employee.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "EMPLOYEE", "rights": "C" } }
                        ]
                    };
                }
                break;
        }



        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();

            var srcRoles = curUser.roles;
            var haveCustomProfiles = curUser.roles.filter(role => role.startsWith("PRFL_"));
            srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
            var targetRoles = srcRoles ? srcRoles[0] : null;

            var employeeModel;
            var srcModel;
            var resFilter = Object.keys(this.employeeModels).filter((key) => {
                var model = this.employeeModels[key];
                if (key === "EMPLOYEE" || key === ("EMPLOYEE_" + this.state.curEmployee?.categoryID)) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "EMPLOYEE_" + targetRoles || (key === ("EMPLOYEE_" + this.state.curEmployee?.categoryID + "_") + targetRoles);
            });
            if (resFilter?.length) {
                employeeModel = this.employeeModels[resFilter[0]];
            }
            else if (srcModel) {
                employeeModel = srcModel;
            }
            else {
                employeeModel = this.employeeModels ? (this.employeeModels["EMPLOYEE_" + this.state.curEmployee?.categoryID] || this.employeeModels[template.subType]) : {};
            }

            var cptSysCollection = {
                "EMPLOYEE": <ShowDetails id={this.state.curEmployeeId} type="employee" genRef={this.employeeGen} data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={employeeModel} modelsList={this.employeeModels} loadElem={this.loadEmployee.bind(this)} saveElem={this.contextSaveEmployee.bind(this)} removeElem={this.removeEmployee.bind(this)} updateStatusElem={this.updateEmployeeStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} />,
                "CONTRACTS": <ShowDetails id={this.state.curEmployeeId} type="employeeContracts" data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["CONTRACTS"] : {}} modelsList={this.employeeModels} shouldRender={this.state.activeTab === index.toString()} />,
                "CONTACTS": <ShowDetails id={this.state.curEmployeeId} type="employeeContacts" data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["CONTACTS"] : {}} modelsList={this.employeeModels} shouldRender={this.state.activeTab === index.toString()} />,
                "EVENTS": <ShowDetails id={this.state.curEmployeeId} type="employeeItvs" data={this.state.curEmployee} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.employeeModels ? this.employeeModels["ITVS"] : {}} modelsList={this.employeeModels} loadElem={this.loadEmployee.bind(this)} shouldRender={this.state.activeTab === index.toString()} />,
                "M_ACCESS": <Row className="employee-access">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("employee.accessTitle")}</CardTitle>
                                {hasCustomRights ? <div className="header-infos"><i className="fa fa-circle-check text-success ms-3 me-2"></i>Paramètrages utilisateur chargés</div> : ""}
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-lock fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                {context.state.activeTab === index.toString() ? <ManageRights context={context} employeeData={this.state.curEmployee} groupsConfig={modelAccesTab?.groups} rolesConfig={modelAccesTab?.roles} shouldRender={context.state.activeTab === index.toString()} /> : ""}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
                "M_MENU": <Row className="employee-menu">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("employee.menuTitle")}</CardTitle>
                                {hasCustomMenu ? <div className="header-infos"><i className="fa fa-circle-check text-success ms-3 me-2"></i>Paramètrages utilisateur chargés</div> : ""}
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-list fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                {context.state.activeTab === index.toString() ? <ManageMenu context={context} employeeData={this.state.curEmployee} shouldRender={context.state.activeTab === index.toString()} /> : ""}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="employee-files" bindID={this.state.curEmployeeId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="EMPLOYEE" src={this.state.curEmployee}
                        srcName={this.state.curEmployee ? this.state.curEmployee.name : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"EGL"}
                        altFilesTypes="../api/employee/GetEmployeeFilesType" altFilesUrl="../api/employee/GetEmployeeFiles" altRemoveFilesUrl="../api/employee/RemoveEmployeeFile" altUploadFilesUrl="../api/employee/UploadEmployeeFiles" />
                </Form>,
                "FLOWS": <Row className="employee-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("employee.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="employee" elemId={context.state.curEmployeeId} url="../api/employee/GetEmployeeFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };

        let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
            <div>
                {this.employeeModels ? <CDataTable key="employees" dtId={"tableEmployees"} data={this.state.employees} localConfig={dtConfig} tag={"DT_SALS"} config={this.employeeModels["DT_SALS"]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
            </div>;


        var connectedUser = (this.props.getUser ? this.props.getUser() : null);
        var curEmpUser = this.state.curEmployee?.accountUser?.localUser;
        var modelAccesTab = (curEmpUser && context.employeeModels) ? context.employeeModels["ACCESSTAB"] : null;
        var accessTabAllowed = curEmpUser?.id !== connectedUser.id && (modelAccesTab?.roles ? (modelAccesTab.roles.filter(role => curEmpUser?.roles.indexOf(role) >= 0).length <= 0)
            : (curEmpUser?.roles.indexOf("Souscription") < 0 && curEmpUser?.roles.indexOf("AdminDed") < 0 && curEmpUser?.roles.indexOf("Admin") < 0));

        var hasCustomMenu = true;//TODO : chargement des rights/menu
        var hasCustomRights = true;//TODO : chargement des rights/menu

        var displayedTemplates = pageConfig?.templates?.filter(template => template.objType === "template" && (!template.subType?.startsWith("M_") || accessTabAllowed));

        if ((!accessTabAllowed && this.state.curEmployee) && (parseInt(this.state.activeTab) > displayedTemplates.length)) this.switchTab("1");

        return (
            <div className="tableDetails">
                <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                    <CardHeader>
                        <CardTitle tag="h6">{context.props.i18nManager.t("employee.title")}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-table-list fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="float-start">
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getEmployees()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {pageConfig?.templates?.map((template, index) => {
                                if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                    switch (template.subType) {
                                        case "ADD":
                                            return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateEmployee()}>
                                                <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("employee.add")}
                                            </Button>;
                                        default: return "";
                                    }
                                }
                                else return "";
                            })}
                        </div>
                        <CNavbar className="float-end">
                            <div className="text-end">
                                {this.state.status.map((dt) => {

                                    //TODO : statusBtnAltProc

                                    var statusClass = "form-badge-radio mb-1 ";
                                    statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                    return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                        <div className='form-check-radio fcheck-sm mb-0'>
                                            <Label check >
                                                <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                    var value = parseInt(e.target.value);

                                                    context.setState({ curStatus: value, curEmployeeId: 0, curEmployee: null, isShowDetails: false });
                                                }} />
                                                <span className="form-check-sign" />
                                                {(() => {
                                                    var classFa = "";
                                                    if (dt.css && dt.css.indexOf("fa-")) {
                                                        dt.css.split(" ").forEach((classElem) => {
                                                            //console.debug(classElem.startsWith("fa-") + classElem);
                                                            classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                        });
                                                    }
                                                    return <i className={`fa ${classFa} me-1`}></i>
                                                })()}
                                                {altT(dt.name)}
                                            </Label>
                                        </div>
                                    </div> : "";
                                })}
                            </div>
                        </CNavbar>
                        {contents}
                    </CardBody>
                </Card>

                {this.state.isShowDetails ? (<div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                                <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curEmployeeId || 0;
                                        showDtPrevID("tableEmployees", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curEmployeeId || 0;
                                        showDtNextID("tableEmployees", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                {displayedTemplates.map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : ""))}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {displayedTemplates.map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) ? getSysCpt(template, index + 1) : "")}
                    </TabContent></div>) : ""}
            </div>
        );
    }

    async getEmployees(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ employees: [], curEmployeeId: 0, curEmployee: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus || 1000;

        commonFunc.getMethod("../api/employee/GetEmployees", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {

                    /*$('#lstActs thead th').each(function () {
                        var title = $(this).text();
                        if ($(this).hasClass("searchable")) {
                            $(this).append('<input type="text" class="form-control col-lg-12 form-control-sm" placeholder="' + title + '" />');
                        }
                    });*/

                    Swal.close();
                    context.setState({ employees: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("employee.failLoadEmployees") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("employee.failLoadEmployees")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/employee/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadEmployee(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("employee.noSelected"), curEmployeeId: 0, curEmployee: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;
            args.level = 2;
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                commonFunc.getMethod("../api/employee/GetEmployee", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {

                        var finalizeLoadEmployee = () => {
                            if (data.result?.contracts?.length) {
                                var contractSiteIDs = [];
                                data.result.cContractSites = data.result.contracts.map(contract => {
                                    if (contractSiteIDs.indexOf(contract.siteID) < 0) {
                                        contractSiteIDs.push(contract.siteID);
                                        return contract.siteID;
                                    }
                                    else {
                                        return null;
                                    }
                                }).filter((elem => elem != null)).join(";");
                            }

                            if (callback && typeof (callback) === "function") { callback(data); }

                            Swal.close();

                            //data.result.trigram
                            if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.name + " " + data.result.firstName), curEmployeeId: id, curEmployee: data.result, isShowDetails: true });
                        };

                        if (data.result.accountUser?.localUserID) {
                            commonFunc.getMethod("../api/employee/GetEmployeeAccount", { userId: data.result.accountUser.localUserID }).then((responseUser) => {
                                var dataUser = responseUser.data;
                                if (dataUser.isSuccess) {
                                    console.log(dataUser.result);

                                    data.result.accountUser.localUser = dataUser.result;

                                    //data.result.roles = data.result.accountUser.localUser.roles[0];
                                    var srcRoles = data.result.accountUser.localUser.roles;
                                    var haveCustomProfiles = srcRoles.filter(role => role.startsWith("PRFL_"));
                                    srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
                                    var targetRoles = srcRoles ? srcRoles[0] : null;
                                    data.result.roles = targetRoles;

                                    finalizeLoadEmployee();
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_error"),
                                        html: context.props.i18nManager.t("employee.failLoadEmployee") + " :<br>" + dataUser.errorMessage
                                    });
                                }
                                resolve(dataUser);
                            });
                        }
                        else finalizeLoadEmployee();

                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("employee.failLoadEmployee") + " :<br>" + data.errorMessage
                        });
                        resolve(data);
                    }
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async contextSaveEmployee(userEmployee, isUpdate) {
        var context = this;

        return saveEmployee(userEmployee, context.state.curEmployee, isUpdate, { translation: context.props.i18nManager.t }).then((employeeResponse) => {
            context.loadEmployee(employeeResponse.idEmployee);//userEmployee.idEmployee

            return new Promise((resolve, reject) => {
                resolve(employeeResponse);
            });
        });
    }

    removeEmployee(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curEmployee;
            if ((!id && row) || (id && row && id === row.idEmployee)) {
                id = id || row.idEmployee;
                title = row.name + " " + row.firstName;
            }
            if (parseInt(id) > 0) {
                if (row.accountID > 0 && row.accountUser?.isActive) {
                    Swal.fire({
                        icon: "warning",
                        title: context.props.i18nManager.t("gal_rmvTitle"),
                        html: context.props.i18nManager.t("gal_rmvAccWarn")
                    });
                }
                else {
                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("gal_removing"),
                        html: context.props.i18nManager.t("employee.rmvTitle") + "<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("employee.removing"),
                                didOpen: () => { Swal.showLoading() }
                            });
                            var req = { id: id, isPermanent: false };
                            commonFunc.postMethod("../api/employee/RemoveEmployee", req).then((response) => {
                                Swal.close();
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    context.getEmployees();//TODO : check si besoin de refresh supplémentaire
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(data);
                            });

                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateEmployeeStatus(statusId, stepId, customLabel) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = context.state.curEmployeeId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    var reloadEmployee = true;

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");


                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("employee.updStatus"),
                        html: context.props.i18nManager.t("employee.statusAs", [label]),
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("employee.updatingStatus"),
                                didOpen: () => { Swal.showLoading() },
                            });
                            var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                            commonFunc.postMethod("../api/employee/UpdateStatus", req).then((response) => {

                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    //if (reloadEmployee) context.loadEmployee(id);
                                    //context.getEmployees();//TODO : check si besoin de refresh supplémentaire
                                    /*context.getEmployees(0, true, () => {
                                        if (reloadEmployee) showDtSelID("tableEmployees", id);
                                    });*///TODO : check si besoin de refresh supplémentaire
                                    if (reloadEmployee) context.loadEmployee(id);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(response.data);
                            });
                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    initCreateEmployee() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableEmployees");
        //this.employeeGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("employee.create"), curEmployeeId: 0, curEmployee: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;
        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curEmployee ? (this.state.curEmployee.name + " " + this.state.curEmployee.firstName) : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("employee.duplicate") : this.props.i18nManager.t("employee.edit"))  + " - " + title, editionMode: value });
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageEmployees));


function ManageMenu(props) {
    var { context, employeeData, shouldRender } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

    const [roleMenuItems, setRoleMenuItems] = React.useState([{ "icon": "fa fa-file-signature", "name": "Module Custom", "path": "/ManageCustom", "layout": "", "redirect": true, "keyComponent": "ManageCustom" }, { "icon": "fa fa-home", "name": "Accueil", "path": "/Home", "index": true, "entity": "DASHBOARD", "layout": "", "rights": "L", "keyComponent": "home" }, { "icon": "fa fa-download", "name": "Contrôles TG", "path": "/ManageCustom?key=ANOMALIE", "entity": "CUSTOM_ANOMALIE", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fa fa-envelope", "name": "Envoi des plannings", "path": "/ManageCustom?key=EMPHOURS", "entity": "CUSTOM_EMPHOURS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads", "entity": "LEAD", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads?pageModels=DIALOGLEAD&categoryGroupKey=PROSPECT", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "DEV Prospect Client", "path": "/ManageClients", "entity": "CLIENT", "layout": "", "rights": "L", "keyComponent": "ManageClients" }, { "icon": "fas fa-hard-drive", "name": "Documents partagés", "path": "/ManageFiles", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageFiles" }, { "icon": "fa fa-clipboard-list", "name": "Enquêtes", "path": "/ManageLeads?pageModels=SURVEY&categoryGroupKey=SURVEY", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fa fa-chart-area", "name": "Gestion Stats", "path": "/ManageCustom?key=STATS", "entity": "CUSTOM_STATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-toolbox", "name": "Boîte à outils", "state": "toolboxCollapse", "views": [{ "mini": "E", "name": "Employés", "path": "/ManageEmployees", "entity": "EMPLOYEE", "layout": "", "rights": "L", "keyComponent": "ManageEmployees" }, { "mini": "A", "name": "Agences", "path": "/ManageSites", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageSites" }, { "mini": "C", "name": "Gestion contenu", "path": "/ManageContent", "entity": "CUSTOM", "layout": "", "rights": "L", "keyComponent": "ManageContent" }, { "mini": "A", "name": "Gérer l'abonnement", "path": "/ManageSubscriptions", "entity": "SUBSCRIPTION", "layout": "", "rights": "L", "keyComponent": "ManageSubscriptions" }, { "mini": "U", "name": "Utilisateurs", "path": "/ManageUsers", "entity": "USER", "layout": "", "rights": "L", "keyComponent": "manageUsers" }, { "mini": "J", "name": "Jobs", "path": "/ManageJobs", "entity": "JOBS", "layout": "", "rights": "L", "keyComponent": "ManageJobs" }, { "mini": "L", "name": "Logs", "path": "/ManageCustom?key=LOGS", "entity": "CUSTOM_LOGS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }], "entity": "TOOLS", "rights": "L", "collapse": true }, { "icon": "fas fa-file-signature", "name": "Etat des lieux", "path": "/ManageReportsItv", "entity": "REPORT", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageReportsItv" }, { "icon": "fas fa-car", "name": "Véhicules", "state": "vehicleCollapse", "views": [{ "mini": "G", "name": "Gestion Véhicules", "path": "/ManageMaterials", "entity": "MATERIAL", "layout": "", "rights": "L", "pathOLD": "/ManageMaterials?categoryGroupKey=VCL", "keyComponent": "ManageMaterials" }, { "mini": "P", "name": "Planning Matériel", "path": "/matPlanning", "entity": "MATERIAL_EVENTS", "layout": "", "rights": "L", "keyComponent": "fcPlanningMat" }, { "mini": "S", "name": "Suivi Véhicules", "path": "/ManageCustom?key=CARSSTATS", "entity": "CUSTOM_CARSSTATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "mini": "E", "name": "Etat des lieux", "path": "/ManageReportsItv?reportId=1&statusId=202", "entity": "REPORT", "layout": "", "rights": "L", "keyComponent": "ManageReportsItv" }, { "mini": "B", "name": "Badgeage Véhicules", "path": "/ManageTG", "entity": "WORKEVENT", "layout": "", "rights": "L", "keyComponent": "ManageTG" }], "entity": "", "rights": "", "collapse": true }, { "icon": "fas fa-computer", "name": "Parc Info.", "path": "/ManageMaterials?categoryGroupKey=INFO&pageModels=INFO", "entity": "MATERIAL", "layout": "", "rights": "L", "keyComponent": "ManageMaterials" }, { "icon": "fas fa-calendar", "name": "Planning", "path": "/planning", "entity": "PLANNING", "layout": "", "rights": "L", "keyComponent": "fcPlanning" }, { "icon": "fas fa-life-ring", "name": "Demandes d'assistance", "path": "/ManageTickets", "entity": "TICKET", "layout": "", "rights": "L", "keyComponent": "ManageTickets" }, { "icon": "fa fa-user", "name": "Pages", "path": "/showContent", "layout": "", "redirect": true, "keyComponent": "showContent" }, { "tag": "RH", "icon": "fa fa-user", "name": "RH", "state": "rhCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true }, { "tag": "TAB", "icon": "fas fa-list", "name": "TAB", "state": "tabCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }, { "tag": "DOC", "icon": "fa fa-book-bookmark", "name": "Documents", "state": "docCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }]);
    const [userMenuItems, setUserMenuItems] = React.useState([{ "icon": "fa fa-file-signature", "name": "Module Custom", "path": "/ManageCustom", "layout": "", "redirect": true, "keyComponent": "ManageCustom" }, { "icon": "fa fa-home", "name": "Accueil", "path": "/Home", "index": true, "entity": "DASHBOARD", "layout": "", "rights": "L", "keyComponent": "home" }, { "icon": "fa fa-download", "name": "Contrôles TG", "path": "/ManageCustom?key=ANOMALIE", "entity": "CUSTOM_ANOMALIE", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads", "entity": "LEAD", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "Prospect Lead", "path": "/ManageLeads?pageModels=DIALOGLEAD&categoryGroupKey=PROSPECT", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fas fa-users", "name": "DEV Prospect Client", "path": "/ManageClients", "entity": "CLIENT", "layout": "", "rights": "L", "keyComponent": "ManageClients" }, { "icon": "fas fa-hard-drive", "name": "Documents partagés", "path": "/ManageFiles", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageFiles" }, { "icon": "fa fa-clipboard-list", "name": "Enquêtes", "path": "/ManageLeads?pageModels=SURVEY&categoryGroupKey=SURVEY", "entity": "LEAD", "layout": "", "rights": "L", "keyComponent": "ManageLeads" }, { "icon": "fa fa-chart-area", "name": "Gestion Stats", "path": "/ManageCustom?key=STATS", "entity": "CUSTOM_STATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "icon": "fas fa-toolbox", "name": "Boîte à outils", "state": "toolboxCollapse", "views": [{ "mini": "E", "name": "Employés", "path": "/ManageEmployees", "entity": "EMPLOYEE", "layout": "", "rights": "L", "keyComponent": "ManageEmployees" }, { "mini": "A", "name": "Agences", "path": "/ManageSites", "entity": "SITE", "layout": "", "rights": "L", "keyComponent": "ManageSites" }, { "mini": "C", "name": "Gestion contenu", "path": "/ManageContent", "entity": "CUSTOM", "layout": "", "rights": "L", "keyComponent": "ManageContent" }, { "mini": "A", "name": "Gérer l'abonnement", "path": "/ManageSubscriptions", "entity": "SUBSCRIPTION", "layout": "", "rights": "L", "keyComponent": "ManageSubscriptions" }, { "mini": "U", "name": "Utilisateurs", "path": "/ManageUsers", "entity": "USER", "layout": "", "rights": "L", "keyComponent": "manageUsers" }, { "mini": "J", "name": "Jobs", "path": "/ManageJobs", "entity": "JOBS", "layout": "", "rights": "L", "keyComponent": "ManageJobs" }, { "mini": "L", "name": "Logs", "path": "/ManageCustom?key=LOGS", "entity": "CUSTOM_LOGS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }], "entity": "TOOLS", "rights": "L", "collapse": true }, { "icon": "fas fa-file-signature", "name": "Etat des lieux", "path": "/ManageReportsItv", "entity": "REPORT", "layout": "", "rights": "L", "redirect": true, "keyComponent": "ManageReportsItv" }, { "icon": "fas fa-car", "name": "Véhicules", "state": "vehicleCollapse", "views": [{ "mini": "G", "name": "Gestion Véhicules", "path": "/ManageMaterials", "entity": "MATERIAL", "layout": "", "rights": "L", "pathOLD": "/ManageMaterials?categoryGroupKey=VCL", "keyComponent": "ManageMaterials" }, { "mini": "P", "name": "Planning Matériel", "path": "/matPlanning", "entity": "MATERIAL_EVENTS", "layout": "", "rights": "L", "keyComponent": "fcPlanningMat" }, { "mini": "S", "name": "Suivi Véhicules", "path": "/ManageCustom?key=CARSSTATS", "entity": "CUSTOM_CARSSTATS", "layout": "", "rights": "L", "keyComponent": "ManageCustom" }, { "mini": "E", "name": "Etat des lieux", "path": "/ManageReportsItv?reportId=1&statusId=202", "entity": "REPORT", "layout": "", "rights": "L", "keyComponent": "ManageReportsItv" }, { "mini": "B", "name": "Badgeage Véhicules", "path": "/ManageTG", "entity": "WORKEVENT", "layout": "", "rights": "L", "keyComponent": "ManageTG" }], "entity": "", "rights": "", "collapse": true }, { "icon": "fas fa-computer", "name": "Parc Info.", "path": "/ManageMaterials?categoryGroupKey=INFO&pageModels=INFO", "entity": "MATERIAL", "layout": "", "rights": "L", "keyComponent": "ManageMaterials" }, { "icon": "fas fa-calendar", "name": "Planning", "path": "/planning", "entity": "PLANNING", "layout": "", "rights": "L", "keyComponent": "fcPlanning" }, { "icon": "fas fa-life-ring", "name": "Demandes d'assistance", "path": "/ManageTickets", "entity": "TICKET", "layout": "", "rights": "L", "keyComponent": "ManageTickets" }, { "icon": "fa fa-user", "name": "Pages", "path": "/showContent", "layout": "", "redirect": true, "keyComponent": "showContent" }, { "tag": "RH", "icon": "fa fa-user", "name": "RH", "state": "rhCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true }, { "tag": "TAB", "icon": "fas fa-list", "name": "TAB", "state": "tabCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }, { "tag": "DOC", "icon": "fa fa-book-bookmark", "name": "Documents", "state": "docCollapse", "views": [], "entity": "CUSTOM_PGE", "rights": "L", "collapse": true, "redirect": true, "pgeContainer": true }]);


    function manageElements(item, state) {
        var srcItems;
        if (item.parent) {
            var userParentMenu = userMenuItems.filter(parents => parents.state === item.parent);
            if (userParentMenu.length && userParentMenu[0].views) {
                if (state) {
                    userParentMenu[0].views.push({ ...item });
                }
                else {
                    userParentMenu[0].views = userParentMenu[0].views.filter(listItem => !(item.name === listItem.name && item.path === listItem.path));
                }

                srcItems = roleMenuItems.map(listItem => {
                    var returnedItem = listItem;
                    var userParent = userMenuItems.filter(userItem => (returnedItem.name === userItem.name && returnedItem.path === userItem.path));
                    if (listItem.views) {
                        returnedItem = Object.assign({}, returnedItem);
                        if (userParent.length > 0) {
                            returnedItem.views = returnedItem.views.filter(childListItem => {
                                return userParent[0].views.filter(childUserItem => (childListItem.name === childUserItem.name && childListItem.path === childUserItem.path)).length > 0;
                            });
                        }
                    }
                    return userParent.length > 0 ? returnedItem : null;
                }).filter(item => item !== null);
                setUserMenuItems(JSON.parse(JSON.stringify(srcItems)));
            }
        }
        else {
            if (state) {
                userMenuItems.push({ ...item });
                srcItems = roleMenuItems.filter(listItem => {
                    return userMenuItems.filter(userItem => (listItem.name === userItem.name && listItem.path === userItem.path)).length > 0;
                });
            }
            else {
                srcItems = userMenuItems.filter(listItem => !(item.name === listItem.name && item.path === listItem.path));
            }
            setUserMenuItems(JSON.parse(JSON.stringify(srcItems)));
        }
    }

    function saveMenu() {
        Swal.fire({
            title: context.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var newMenuParams = userMenuItems;

        var req = { id: employeeData.idEmployee, newMenu: newMenuParams };
        commonFunc.postMethod("../api/employee/UpdateMenuAccess", req).then((response) => {//TODO

            Swal.close();
            if (response.data && response.data.isSuccess) {
                context.loadEmployee(employeeData.idEmployee);
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_fail") + "<br/>" + response.data.errorMessage
                });
            }
        });
    }
    
    if (roleMenuItems?.length && userMenuItems?.length) {
        roleMenuItems.forEach(item => {
            var echosItem = userMenuItems.filter(userItem => (item.name === userItem.name && item.path === userItem.path));
            item.isActive = echosItem.length > 0;
        });
    }
    var displayItems = roleMenuItems?.filter(srcItem => (!srcItem.path || srcItem.path.indexOf("ManageSubscription") < 0) && !srcItem.redirect);


    return (shouldRender && displayItems?.length) ? <div className="manage-menu">
        <Button className="btn-rotate px-2 btn-simple mt-0" color="dark" size="sm" onClick={() => context.loadEmployee(employeeData.idEmployee)}>
            <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh") + "/" + context.props.i18nManager.t("gal_cancel")}
        </Button>
        <Button className="btn-magnify px-2 mt-0" color="primary" size="sm" onClick={() => saveMenu()}>
            <i className="fa fa-save"></i>{context.props.i18nManager.t("gal_save")}
        </Button>
        <div className="mm-list">
            {displayItems?.map((item, index) => <MenuItem {...props} key={"item" + index + item.name} nodeID={index + item.name.replaceAll(" ", "")} data={item} isActive={item.isActive} manageElements={manageElements} />)}
        </div>
    </div> : <p className="text-center align-content-center"><i className="fa fa-circle-notch fa-spin fa-2x"></i></p>;
}

function MenuItem(props) {
    var { data, parentData, context, nodeID, manageElements } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
    var customItemT = (label, args) => { return (label && context.props.i18nManager.t("accessitem." + label) !== "accessitem." + label) ? context.props.i18nManager.t("accessitem." + label) : label };

    const [checked, setChecked] = React.useState(props.isActive);
    const [collapsed, setCollapsed] = React.useState(false);//TEMP

    return <div className="ms-2">
        <div className={`items-container d-flex align-items-center px-1`} style={checked ? { backgroundColor: "#AAAAAA66", borderRadius: "5px" } : {}}>
            <span className={`p-1 cursor-pointer ${data.views?.length ? "" : "invisible"}`} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setCollapsed(!collapsed);
            }}>{(collapsed ? <i className="fa fa-angle-right me-1 mt-1 text-muted" style={{ width: "10px" }}></i> : <i className="fa fa-angle-down me-1 mt-1" style={{ width: "10px" }}></i>)}</span>
            <div className={`form-check form-check-inline fcheck-sm form-group float-sm-end m-0 me-3`} style={{ minHeight: "0px" }}>
                <Label check for={"node" + nodeID} className={`d-inline-block px-0 w-100`} style={{ minWidth: "16px" }}>
                    <div className={`d-inline-block`} style={{ position: "relative", top: "-12px" }}>
                        <Input type="checkbox" id={"node" + nodeID} checked={checked} onChange={(e) => {
                            setChecked(!checked);

                            //TODO : change data direct ?!
                            if (data.mini && parentData) data.parent = parentData.state;
                            manageElements(data, !checked);
                        }} />
                        <span className={`form-check-sign`} />
                    </div>
                    <div className={`d-inline-block ms-4 px-0`}>
                        <i className={`${data.icon ? "text-dark " + data.icon : (data.mini ? ("text-secondary fa fa-" + data.mini?.toLowerCase()) : "text-secondary fa fa-square")} me-1`}></i> <span title={data.path} style={{ flex: "auto" }}>{customItemT(data.name)}</span>
                    </div>
                </Label>
            </div>
            
        </div>
        {data.isActive && !collapsed && data.views?.map((subItem, index) => !subItem.redirect ? <MenuItem {...props} key={"subItem" + data.name.replaceAll(" ", "") + index + subItem.name.replaceAll(" ", "")} nodeID={data.name.replaceAll(" ", "") + index + subItem.name.replaceAll(" ", "")} parentData={data} data={subItem} /> : "")}
    </div>;
}


function ManageRights(props) {
    var { context, employeeData, groupsConfig, rolesConfig, shouldRender } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

    const [roleRightsItems, setRoleRightsItems] = React.useState([{ "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_DEMANDS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_AGREEMENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_ACCOUNT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_EVENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_GROUPS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_DEMANDS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_AGREEMENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_EVENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_CONTRACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_ACCOUNT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_GROUPS" }, { "value": "RULSA", "active": true, "extId": 0, "entity": "SITE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SITE_CONTACTS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "SITE_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SITE_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SITE_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PLANNING" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "WORKEVENT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_FLOWS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "desc": "Accès Ticket", "entity": "TICKET" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Maj Ticket", "entity": "TICKET_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Contacts", "entity": "TICKET_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Histo", "entity": "TICKET_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Lead", "entity": "TICKET_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "TICKET_GROUPS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "desc": "Accès Lead", "entity": "LEAD" }, { "value": "CRUDLSA", "active": true, "extId": 0, "desc": "Accès Maj Lead", "entity": "LEAD_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Contacts", "entity": "LEAD_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Histo", "entity": "LEAD_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Lead", "entity": "LEAD_MODELS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "MATERIAL" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_ASSIGN" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_GROUPS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_EVENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "DASHBOARD" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "TOOLS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "JOBS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PARAMS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PARAMS_SERVICES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PARAMS_CONTENT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SUBSCRIPTION" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "USER" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "USER_ACCOUNT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SERVICE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_PGE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_PGE_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_LOGS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_VEHICLE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_ANOMALIE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_STATS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_STATS_LIVE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_CARSSTATS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_GEIST" }, { "value": "A", "active": true, "extId": 0, "entity": "NOTIF" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "CUSTOM_EMPHOURS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "TOTO_TEST" }]);
    const [userRightsItems, setUserRightsItems] = React.useState([{ "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_DEMANDS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_AGREEMENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_ACCOUNT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_EVENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CLIENT_GROUPS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE" }, { "value": "CL", "active": true, "extId": 0, "entity": "EMPLOYEE_FILES" }, { "value": "", "active": true, "extId": 0, "entity": "EMPLOYEE_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_DEMANDS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_AGREEMENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_EVENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_CONTRACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_ACCOUNT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "EMPLOYEE_GROUPS" }, { "value": "RULSA", "active": true, "extId": 0, "entity": "SITE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SITE_CONTACTS" }, { "value": "RL", "active": true, "extId": 0, "entity": "SITE_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SITE_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SITE_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PLANNING" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "WORKEVENT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "REPORT_FLOWS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "desc": "Accès Ticket", "entity": "TICKET" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Maj Ticket", "entity": "TICKET_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Contacts", "entity": "TICKET_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Histo", "entity": "TICKET_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Lead", "entity": "TICKET_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "TICKET_GROUPS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "desc": "Accès Lead", "entity": "LEAD" }, { "value": "CRUDLSA", "active": true, "extId": 0, "desc": "Accès Maj Lead", "entity": "LEAD_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Contacts", "entity": "LEAD_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Accès Histo", "entity": "LEAD_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "desc": "Lead", "entity": "LEAD_MODELS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "MATERIAL" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_FILES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_CONTACTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_ASSIGN" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_FLOWS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_GROUPS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "MATERIAL_EVENTS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "DASHBOARD" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "TOOLS" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "JOBS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PARAMS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PARAMS_SERVICES" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "PARAMS_CONTENT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SUBSCRIPTION" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "USER" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "USER_ACCOUNT" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "SERVICE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_PGE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_PGE_MODELS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_LOGS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_VEHICLE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_ANOMALIE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_STATS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_STATS_LIVE" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_CARSSTATS" }, { "value": "CRUDLS", "active": true, "extId": 0, "entity": "CUSTOM_GEIST" }, { "value": "A", "active": true, "extId": 0, "entity": "NOTIF" }, { "value": "CRUDLSA", "active": true, "extId": 0, "entity": "CUSTOM_TEST" }]);
    const [roles, setRoles] = React.useState(null);


    React.useEffect(() => {
        getRoles();
    }, []);

    function getRoles() {
        commonFunc.getMethod("../api/GetRoles", null).then((response) => {
            var data = response.data;
            if (data.isSuccess) {
                setRoles(data.result);
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html:  data.errorMessage
                });
            }
        });
    }

    function manageRights(item, right, state) {
        var newRights = userRightsItems;
        if (state) {
            var rightsTab = ["C", "R", "U", "D", "L", "S", "A"];

            var targetT = newRights.filter(listItem => item.entity === listItem.entity);
            if (targetT.length) {
                var concatRights = "";
                rightsTab.forEach((tabItem, index) => {
                    if (targetT[0].value.indexOf(tabItem) >= 0 || tabItem === right) concatRights += tabItem;
                });
                targetT[0].value = concatRights;

                setUserRightsItems(newRights);
            }
            else {
                newRights.push({ "value": right, "active": true, "extId": 0, "entity": item.entity });
                setUserRightsItems(newRights);
            }
        }
        else {
            var target = newRights.filter(listItem => item.entity === listItem.entity);
            if (target.length) {
                target[0].value = target[0].value.replace(right, "");

                setUserRightsItems(newRights);
            }
            else {
                newRights.push({ "value": "", "active": true, "extId": 0, "entity": item.entity });
                setUserRightsItems(newRights);
            }
        }
    }

    function saveRights() {
        Swal.fire({
            title: context.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var newRightsParams = roleRightsItems;

        var req = { id: employeeData.idEmployee, newRights: newRightsParams };
        commonFunc.postMethod("../api/employee/UpdateRightsAccess", req).then((response) => {//TODO

            Swal.close();
            if (response.data && response.data.isSuccess) {
                context.loadEmployee(employeeData.idEmployee);
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_fail") + "<br/>" + response.data.errorMessage
                });
            }
        });
    }

    //var displayItems = roleMenuItems.filter(srcItem => (!srcItem.path || srcItem.path.indexOf("ManageSubscription") < 0) && !srcItem.redirect);
    var displayItems = roleRightsItems;

    if (groupsConfig && displayItems?.length) {
        groupsConfig.forEach(group => {
            var groupRight = { "value": "CRUDLS", "active": true, "extId": 0, "entity": "G-" + group, isGroup: true };
            var rightsFiltered = roleRightsItems.filter(right => (right.entity === group || right.entity.startsWith(group + "_")));
            groupRight.childs = rightsFiltered;

            displayItems = displayItems.filter(right => !(right.entity === group || right.entity.startsWith(group + "_")));
            displayItems.unshift(groupRight);
        });
        displayItems.sort((a, b) => a.entity.localeCompare(b.entity));
    }


    var srcRoles = employeeData.accountUser.localUser.roles;
    var haveCustomProfiles = employeeData.accountUser.localUser.roles.filter(role => role.startsWith("PRFL_"));
    srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
    var targetRoles = srcRoles ? srcRoles[0] : null;

    return (shouldRender && displayItems?.length) ? <div className="manage-rights">
        <Button className="btn-rotate px-2 btn-simple mt-0" color="dark" size="sm" onClick={() => context.loadEmployee(employeeData.idEmployee)}>
            <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh") + "/" + context.props.i18nManager.t("gal_cancel")}
        </Button>
        <Button className="btn-magnify px-2 mt-0" color="primary" size="sm" onClick={() => saveRights()}>
            <i className="fa fa-save"></i>{context.props.i18nManager.t("gal_save")}
        </Button>
        {employeeData.accountUser?.localUser?.roles && roles?.length ? <div>
            <Label className="role-updater-label" for="roleUpdater">{context.props.i18nManager.t("employee.roleUpdater") + targetRoles[0]}</Label>
            <Input id={"roleUpdater"} bsSize="sm" className="role-updater" type="select" onChange={(e) => {
                //TODO : changement de role !!!
            }} value={targetRoles[0]}>
                {roles.filter(role => parseInt(role.description) === employeeData.accountUser.primarySid && (!rolesConfig || rolesConfig.indexOf(role.name) <= 0)).map(role => {
                    return <option value={role.name}>{role.normalizedName}</option>
                })}
            </Input>
            <div className="hr-line-solid"></div>
        </div> : ""}
        <div className="mr-list">
            {displayItems?.map((srcRight, index) => <RightItem {...props} key={"right" + index + srcRight.entity} nodeID={index + srcRight.entity} data={srcRight}
                manageRights={manageRights} roleRightsItems={roleRightsItems} userRightsItems={userRightsItems} />)}
        </div>
    </div> : <p className="text-center align-content-center"><i className="fa fa-circle-notch fa-spin fa-2x"></i></p>;
}

function RightItem(props) {
    var { data, context, nodeID, manageRights, roleRightsItems, userRightsItems } = props;

    var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
    var customItemT = (label, args) => { return (label && context.props.i18nManager.t("accessitem." + label.toLowerCase()) !== "accessitem." + label.toLowerCase()) ? context.props.i18nManager.t("accessitem." + label.toLowerCase()) : label };

    const [checked, setChecked] = React.useState(() => {
        if (data.isGroup) {
            var groupChecked = { "C": true, "R": true, "U": true, "D": true, "L": true, "S": true, "A": true };
            data.childs.forEach(child => {
                var filteredUserRights = userRightsItems?.filter(userRight => userRight.entity === child.entity);
                if (filteredUserRights?.length) {
                    groupChecked["C"] &= filteredUserRights[0].value.indexOf("C") >= 0;
                    groupChecked["R"] &= filteredUserRights[0].value.indexOf("R") >= 0;
                    groupChecked["U"] &= filteredUserRights[0].value.indexOf("U") >= 0;
                    groupChecked["D"] &= filteredUserRights[0].value.indexOf("D") >= 0;
                    groupChecked["L"] &= filteredUserRights[0].value.indexOf("L") >= 0;
                    groupChecked["S"] &= filteredUserRights[0].value.indexOf("S") >= 0;
                    groupChecked["A"] &= filteredUserRights[0].value.indexOf("A") >= 0;
                }
            });
            return groupChecked;
        }
        else {
            var filteredUserRights = userRightsItems?.filter(userRight => userRight.entity === data.entity);
            if (filteredUserRights?.length) {
                return {
                    "C": filteredUserRights[0].value.indexOf("C") >= 0, "R": filteredUserRights[0].value.indexOf("R") >= 0, "U": filteredUserRights[0].value.indexOf("U") >= 0,
                    "D": filteredUserRights[0].value.indexOf("D") >= 0, "L": filteredUserRights[0].value.indexOf("L") >= 0, "S": filteredUserRights[0].value.indexOf("S") >= 0, "A": filteredUserRights[0].value.indexOf("A") >= 0
                };
            }
        }
        return { "C": false, "R": false, "U": false, "D": false, "L": false, "S": false, "A": false };
    });
    const [collapsed, setCollapsed] = React.useState(false);//TEMP

    var rightsTab = ["C", "R", "U", "D", "L", "S", "A"];

    function manageLabel(right) {
        return altT("i18n:accessitem." + right.entity.toLowerCase());
    }

    function onChange(e, tabRight) {
        var newChecked = checked;
        newChecked[tabRight] = !checked[tabRight];
        setChecked(Object.assign({}, newChecked));

        if (data.isGroup) {
            data.childs.forEach((child) => {
                //manageRights(child, tabRight, newChecked[tabRight]);
                child.cTriggerChecked(tabRight, newChecked[tabRight]);
            });
        }
        else {
            //TODO : change data direct ?!
            manageRights(data, tabRight, newChecked[tabRight]);
        }
    }

    data.cTriggerChecked = (right, state) => {
        //Prevent if disabled
        if (right !== "R" && right !== "L" && data.value.indexOf(right) >= 0) {
            var newChecked = checked;
            newChecked[right] = state;
            setChecked(Object.assign({}, newChecked));
            manageRights(data, right, state);
        }
    };

    return <div className="ms-2">
        <div className={`items-container d-flex align-items-center px-1 ${data.isGroup ? "group-container" : ""}`}>
            <span className={`p-1 cursor-pointer ${data.childs?.length ? "" : "invisible"}`} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setCollapsed(!collapsed);
            }}>{(collapsed ? <i className="fa fa-angle-right me-1 mt-1 text-muted" style={{ width: "10px" }}></i> : <i className="fa fa-angle-down me-1 mt-1" style={{ width: "10px" }}></i>)}</span>
            <span title={data.isGroup ? "" : data.entity} style={{ flex: "auto" }}>{customItemT(data.entity)}</span>
            <div className="float-sm-end">
                {rightsTab.map(tabRight => {
                    //var authorizedItems = roleRightsItems.filter(roleRight => data.entity === roleRight.entity && roleRight.value.indexOf(tabRight) >= 0);
                    var inputSupProps = { disabled: "disabled" };
                    if ((tabRight !== "R" && tabRight !== "L" && (data.isGroup || data.value.indexOf(tabRight) >= 0))) {
                        delete inputSupProps.disabled;
                        inputSupProps.onChange = (e) => {
                            onChange(e, tabRight);
                        };
                    }

                    return (<div key={"right" + nodeID + tabRight} className={`form-check form-check-inline fcheck-sm form-group ${inputSupProps.disabled ? "disabled" : ""}`} style={{ minHeight: "0px" }}>
                        <Label check for={"node" + nodeID + tabRight} className={`d-inline-block px-0 w-100`}>
                            <div className={`d-inline-block`} style={{ position: "relative", top: "-12px" }}>
                                <Input type="checkbox" id={"node" + nodeID + tabRight} checked={checked[tabRight]} {...inputSupProps} />
                                <span className={`form-check-sign`} />
                            </div>
                            <div className={`d-inline-block ms-3 px-0`}>
                                <span style={{ flex: "auto" }}>{tabRight}</span>
                            </div>
                        </Label>
                    </div>)
                })}
            </div>

        </div>
        {!collapsed && data.childs?.map((subItem, index) => !subItem.redirect ? <RightItem {...props} key={"subItem" + data.entity.replaceAll(" ", "") + index + subItem.entity.replaceAll(" ", "")} nodeID={data.entity.replaceAll(" ", "") + index + subItem.entity.replaceAll(" ", "")} parentData={data} data={subItem} /> : "")}
    </div>;
}


export async function saveEmployee(userEmployee, dataEmployee, isUpdate, args) {
    dataEmployee = dataEmployee || {};

    Swal.fire({
        title: args.translation("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });
    try {
    if (isUpdate) {
        if (dataEmployee?.dSysCreat) userEmployee.dSysCreat = dataEmployee.dSysCreat;
    }
    else {
        userEmployee.dSysCreat = new Date();
    }


    if (!userEmployee.avoidMerge) {
        userEmployee = commonFunc.mergeDeep({}, dataEmployee, userEmployee);

        userEmployee.contacts = [];//???
        //userEmployee.contracts = [];
        userEmployee.employeeFiles = [];
        userEmployee.employeeParents = [];
        userEmployee.flows = [];
        userEmployee.skillsAssigned = [];//???
        userEmployee.models = [];

        userEmployee.accountUser = null;
        userEmployee.agencySite = null;
        userEmployee.category = null;
        userEmployee.parent = null;
        userEmployee.group = null;
        userEmployee.site = null;
        userEmployee.extraSite = null;
        userEmployee.status = null;
        userEmployee.subStatus = null;
        userEmployee.tenantUserAccess = null;
    }

    if (userEmployee.contract) {//userEmployee.cContractSites
        var sites = userEmployee.cContractSites.split(";");
        var conservedContractSites = [];
        var oldContracts = dataEmployee.contracts;
        userEmployee.contracts = [];
        sites.forEach((siteContract) => {
            if (!commonFunc.isBlank(siteContract)) {
                var findOldContract = oldContracts?.filter((contract) => contract.siteID === parseInt(siteContract));

                var newContract = {};
                if (isUpdate && findOldContract?.length) {
                    findOldContract.forEach((contract) => {
                        newContract = contract;
                        conservedContractSites.push(newContract.siteID);
                        newContract = Object.assign(newContract, userEmployee.contract);
                        newContract.employeeID = userEmployee.idEmployee;
                        newContract.siteID = parseInt(siteContract);
                        userEmployee.contracts.push(newContract);
                    });
                }
                else {
                    newContract.idContract = 0;
                    newContract = Object.assign(newContract, userEmployee.contract);
                    newContract.employeeID = userEmployee.idEmployee;
                    newContract.siteID = parseInt(siteContract);
                    userEmployee.contracts.push(newContract);
                }
            }
        });
        userEmployee.contract = null;
        userEmployee.cContractSites = null;

        //Suppression des contrats
        if (isUpdate && oldContracts?.length && conservedContractSites?.length < oldContracts?.length) {
            oldContracts.forEach((oldContract) => {
                if (conservedContractSites.indexOf(oldContract.siteID) < 0) {
                    commonFunc.postMethod("../api/employee/RemoveEmployeeContract", { isPermanent: true, id: oldContract.idContract, bindId: userEmployee.idEmployee });
                }
            });
        }
    }
    else {
        userEmployee.contracts = [];
    }

    console.debug(userEmployee);
    //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
    return commonFunc.postMethod(isUpdate ? "../api/employee/UpdateEmployee" : "../api/employee/CreateEmployee", userEmployee).then((response) => {
        Swal.close();
        return new Promise((resolve, reject) => {
            var data = response.data;
            if (data && data.isSuccess) {

                var nextProc = () => {
                    //context.loadEmployee(data.result.idEmployee);//userEmployee.idEmployee
                    data.result.idResponse = data.result.idEmployee;
                    resolve(data.result);
                };


                if (args.noSwal) {
                    nextProc();
                }
                else {
                    Swal.fire({
                        icon: "success",
                        title: args.translation("gal_success"),
                        html: (isUpdate ? args.translation("gal_successUpd") : args.translation("gal_successAdd")),
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        nextProc();
                    });
                }
            } else {
                var supErrors = "";
                if (data.errors && data.errors.length) {
                    supErrors = data.errors.map((error) => {
                        return "<br>" + error.desc + "(" + error.value + ")";
                    });
                }
                Swal.fire({
                    icon: "error",
                    title: args.translation("gal_fail"),
                    html: args.translation("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                });
                resolve(data);
            }
            });
        });

    }
    catch (e) {
        Swal.close();
        Swal.fire({
            icon: "error",
            title: "Erreur",
            didOpen: () => { Swal.hideLoading() },
            html: "Erreur lors de l'envoi du formulaire :<br>" + e
        });
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false, errorMessage: ("Erreur lors de l'envoi du formulaire :<br>" + e) });
    });
}
}